export default __webpack_public_path__ + "media/zurb/img/bryan/pd-2-74731424ae49330a060744adfc51e9a0.png";